// import React, { useContext, useState } from 'react';
import React, { useState } from "react";
import { Form, Button, Input } from "@heroui/react";
import { useNavigate } from "react-router-dom";
// import StoreContext from "../Store";
// import { useBalance } from "../contexts/BalanceContext";
const Login = () => {
  const navigate = useNavigate();
  // const { setBalance, setExposure } = useBalance();
  // const store = useContext(StoreContext);
  // const [email, setemail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [tempToken, setTempToken] = useState("");
  const [requires2fa, setRequires2fa] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigateByRole = (role, requires2faSetup = false) => {
    if (role === 1) {
      navigate(requires2faSetup ? `/admin/twoFactorAuth` : `/admin/dashboard`);
    } else if (role === 3) {
      navigate(`/operator/dashboard`);
    } else {
      navigate(`/user/home`);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await loginUser(username, password);

      if (!response.ok) {
        const errorText = await response.text();
        let errorJson = {};
        try {
          errorJson = JSON.parse(errorText);
        } catch (_) {}
        throw new Error(errorJson.message || errorJson.error || "Login failed.");
      }

      const result = await response.json();

      if (result.requires2fa) {
        setRequires2fa(true);
        setTempToken(result.tempToken);
        setTotpCode("");
        return;
      }

      await saveUserData(result);
      if (result.role === 1) {
        localStorage.setItem(
          "totpEnabled",
          result.requires2faSetup ? "0" : "1"
        );
      }
      navigateByRole(result.role, Boolean(result.requires2faSetup));
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handle2faSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_LOGIN}/user/login/2fa`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tempToken,
            token: totpCode.trim(),
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        let errorJson = {};
        try {
          errorJson = JSON.parse(errorText);
        } catch (_) {}
        throw new Error(
          errorJson.message ||
            errorJson.error ||
            "Invalid authenticator or backup code."
        );
      }

      const result = await response.json();
      await saveUserData(result);
      if (result.role === 1) {
        localStorage.setItem("totpEnabled", "1");
      }
      navigateByRole(result.role, false);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const loginUser = (username, password) => {
    return fetch(`${process.env.REACT_APP_API_LOGIN}/user/login`, {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    });
  };

  const saveUserData = async (data) => {
    const { name, username, role, token, uid } = data;
    localStorage.setItem("name", name);
    localStorage.setItem("role", role);
    localStorage.setItem("jwt", token);
    localStorage.setItem("uid", uid);
    localStorage.setItem("username", username);
  };

  const backToCredentials = () => {
    setRequires2fa(false);
    setTempToken("");
    setTotpCode("");
    setError("");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-cover bg-matka_black">
      <div>
        <a href="/">
          <h1 className="text-3xl font-bold text-white  dark:text-white mb-6">
            Matka
          </h1>
        </a>
      </div>

      {error && (
        <div className="p-4 bg-red-100 text-red-700 mt-10 rounded-lg flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            className="me-2 text-red-700"
            viewBox="0 0 16 16"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="m7.493.015l-.386.04c-1.873.187-3.76 1.153-5.036 2.579C.66 4.211-.057 6.168.009 8.253c.115 3.601 2.59 6.65 6.101 7.518a8.03 8.03 0 0 0 6.117-.98a8 8 0 0 0 3.544-4.904c.172-.701.212-1.058.212-1.887s-.04-1.186-.212-1.887C14.979 2.878 12.315.498 9 .064C8.716.027 7.683-.006 7.493.015m1.36 1.548a6.5 6.5 0 0 1 3.091 1.271c.329.246.976.893 1.222 1.222c.561.751.976 1.634 1.164 2.479a6.8 6.8 0 0 1 0 2.93c-.414 1.861-1.725 3.513-3.463 4.363a6.8 6.8 0 0 1-1.987.616c-.424.065-1.336.065-1.76 0c-1.948-.296-3.592-1.359-4.627-2.993a7.5 7.5 0 0 1-.634-1.332A6.2 6.2 0 0 1 1.514 8c0-1.039.201-1.925.646-2.84c.34-.698.686-1.18 1.253-1.747A6 6 0 0 1 5.16 2.16a6.45 6.45 0 0 1 3.693-.597M7.706 4.29c-.224.073-.351.201-.413.415c-.036.122-.04.401-.034 2.111c.008 1.97.008 1.971.066 2.08a.7.7 0 0 0 .346.308c.132.046.526.046.658 0a.7.7 0 0 0 .346-.308c.058-.109.058-.11.066-2.08c.008-2.152.008-2.154-.145-2.335c-.124-.148-.257-.197-.556-.205a1.7 1.7 0 0 0-.334.014m.08 6.24a.86.86 0 0 0-.467.402a.85.85 0 0 0-.025.563A.78.78 0 0 0 8 12c.303 0 .612-.22.706-.505a.85.85 0 0 0-.025-.563a.95.95 0 0 0-.348-.352c-.116-.06-.429-.089-.547-.05"
            />
          </svg>
          <p className="text-sm">{error}</p>
        </div>
      )}

      <div className="w-full max-w-lg  bg-white dark:bg-themedark-cardbg shadow-lg rounded-lg p-8 border border-gray-300">
        <div className="mb-6 ">
          <div className="py-6 text-2xl font-semibold">
            <h2>{requires2fa ? "Two-Factor Verification" : "Sign In"}</h2>
          </div>

          {!requires2fa ? (
            <Form
              className="w-full max-w-xl flex flex-col gap-6 px-3 py-4"
              onSubmit={(e) => handleClick(e)}
            >
              <Input
                isRequired
                errorMessage="Enter Username"
                size="lg"
                label="Username"
                labelPlacement="outside"
                variant="bordered"
                name="username"
                placeholder="Enter your username"
                type="text"
                value={username}
                required
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />

              <Input
                isRequired
                errorMessage="Enter Password"
                label="Password"
                size="lg"
                labelPlacement="outside"
                variant="bordered"
                name="password"
                placeholder="Enter your password"
                type="password"
                value={password}
                required
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <div className="flex flex-col mt-2 w-full">
                <Button
                  type="submit"
                  className="w-full bg-matka_black text-white"
                  isDisabled={loading}
                >
                  {loading ? "Signing in..." : "Submit"}
                </Button>
              </div>
            </Form>
          ) : (
            <Form
              className="w-full max-w-xl flex flex-col gap-6 px-3 py-4"
              onSubmit={handle2faSubmit}
            >
              <p className="text-sm text-gray-600">
                Enter the 6-digit code from Google Authenticator, or one of your
                one-time backup codes.
              </p>
              <Input
                isRequired
                errorMessage="Enter authenticator or backup code"
                size="lg"
                label="Authenticator or Backup Code"
                labelPlacement="outside"
                variant="bordered"
                name="totp"
                placeholder="000000 or ABCD-EF12"
                type="text"
                autoComplete="one-time-code"
                maxLength={12}
                value={totpCode}
                required
                onChange={(e) => {
                  setTotpCode(
                    e.target.value
                      .replace(/[^a-zA-Z0-9-]/g, "")
                      .slice(0, 12)
                      .toUpperCase()
                  );
                }}
              />
              <div className="flex flex-col gap-2 mt-2 w-full">
                <Button
                  type="submit"
                  className="w-full bg-matka_black text-white"
                  isDisabled={loading || totpCode.replace(/-/g, "").length < 6}
                >
                  {loading ? "Verifying..." : "Verify & Sign In"}
                </Button>
                <Button
                  type="button"
                  variant="light"
                  className="w-full"
                  onClick={backToCredentials}
                  isDisabled={loading}
                >
                  Back
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
